import { api } from '../api'
import { ITable, ServerResponse, TRegion, TRegionDetail } from '../../models/models'

export const regionsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getRegions: builder.query<ITable<TRegion>, any>({
			query: (params) => ({
				url: 'regions',
				params,
			}),
			providesTags: ['region'],
			transformResponse: (response: ServerResponse<ITable<TRegion>>) => ({
        ...response.data,
        data: response.data.data.map((i) => ({ ...i, entityId: i.id }))
      }),
		}),
		getRegionsList: builder.query<TRegion[], any>({
			query: (params) => ({
				url: 'regions',
				params,
			}),
			extraOptions: { replacedUrl: true },
			providesTags: ['region'],
			transformResponse: (response: ServerResponse<TRegion[]>) => response.data
		}),
		getRegionDetail: builder.query<TRegionDetail, { id: string | number }>({
			query: ({ id }) => ({
				url: `regions/${id}`,
			}),
			providesTags: ['region'],
			transformResponse: (response: ServerResponse<TRegionDetail>) => ({
				...response.data,
				ratePerKm: response?.data?.ratePerKm ? response?.data?.ratePerKm / 100 : 0
			})
		}),
		createRegion: builder.mutation<any, { data: any }>({
			query: ({ data }) => ({
				url: 'regions',
				method: 'POST',
				body: data,
			}),
			invalidatesTags: ['region'],
		}),
		editRegion: builder.mutation<any, { id: string | number; data: any }>({
			query: (body) => ({
				url: `regions/${body.id}`,
				method: 'PUT',
				body: body.data,
			}),
			invalidatesTags: ['region'],
		}),
		changeRegionStatus: builder.mutation<any, { id: string | number }>({
			query: (body) => ({
				url: `regions/${body.id}/status`,
				method: 'PUT',
			}),
			invalidatesTags: ['region'],
		}),
    deleteRegion: builder.mutation<ServerResponse<any>, { id: string | number }>({
			query: ({ id }) => ({
				url: `regions/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['region'],
		}),
	}),
})

export const {
	useGetRegionsQuery,
	useGetRegionsListQuery,
  useGetRegionDetailQuery,
  useCreateRegionMutation,
  useEditRegionMutation,
  useChangeRegionStatusMutation,
  useDeleteRegionMutation
} = regionsApi
